import React from 'react';
import { Header, Segment } from 'semantic-ui-react';

import LegacyTabPermissions from './LegacyTabPermissions';

const LEGACY_TABS = [
  {
    label: 'DS Admin',
    subtabs: [
      {label: 'Account Recordings'},
      {label: 'Audit Log'},
      {label: 'Campaign Manager'},
      {label: 'Disposition Manager'},
      {label: 'Recording Redaction'},
      {label: 'RTPQ'},
    ],
  },
  {
    label: 'DS Management',
    subtabs: [
      {label: 'Agent Groups'},
      {label: 'Agent List'},
      {label: 'Agent Status'},
      {label: 'Inbound DID'},
      {label: 'Inbound Status'},
      {label: 'Reports'},
      {label: 'Settings'},
    ],
  },
  {
    label: 'DS User',
  },
];

const LegacyTabPermissionGroup = (props) => {
  return (
    <React.Fragment>
      <Header as="h3">Legacy Tabs</Header>
      <Segment.Group horizontal>
        {LEGACY_TABS.map((tab) => (
          <LegacyTabPermissions key={tab.label} {...tab} />
        ))}
      </Segment.Group>
    </React.Fragment>
  );
};

export default LegacyTabPermissionGroup;
